export const VEHICLE_TYPES = {
  C: 'Car',
  V: 'Van',
  M: 'Bike',
};
